module.exports = __webpack_public_path__ + "static/media/YF15_0.99c7c0c1.jpg";